import PropTypes from 'prop-types'
import React from 'react'

import Icon from 'components/Icon'
import { Text, A } from 'styles/components/typography'

import {
  Wrapper,
  IconBox,
  InnerBox,
  DepartmentName,
  DepartmentWrapper,
  DepartmentNameBox,
} from './styles'

const ContactsCard = props => {
  const {
    title,
    email,
    iconCode,
    personPhoto,
    phoneLink,
    isTranslated,
    withTransform,
  } = props

  const departmentPhone = phoneLink && (
    <Text
      as={A}
      href={`tel:${phoneLink}`}
      isInverted={true}
      dangerouslySetInnerHTML={{ __html: phoneLink }}
    />
  )

  return (
    <Wrapper {...{ personPhoto, withTransform, isTranslated }}>
      <InnerBox>
        <DepartmentWrapper>
          <DepartmentNameBox>
            <DepartmentName dangerouslySetInnerHTML={{ __html: title }} />
          </DepartmentNameBox>
          <Text
            as={A}
            isInverted={true}
            href={`mailto:${email}`}
            dangerouslySetInnerHTML={{ __html: email }}
          />
        </DepartmentWrapper>
      </InnerBox>
      <IconBox>
        <Icon id={iconCode} color="white" />
      </IconBox>
    </Wrapper>
  )
}

ContactsCard.propTypes = {
  /** Person email */
  email: PropTypes.string.isRequired,

  /** Card icon code */
  iconCode: PropTypes.string.isRequired,

  /** Card main title */
  title: PropTypes.string.isRequired,

  /** Flag to set cards translated or not */
  isTranslated: PropTypes.bool,

  /** Person name */
  personName: PropTypes.string,

  /** Person photo code */
  personPhoto: PropTypes.string,

  /** Department phone link (with +{N} country code) */
  phoneLink: PropTypes.string,

  /** Path to load photo of person */
  photoPath: PropTypes.string,

  /** Flag to set transformed cards or not */
  withTransform: PropTypes.bool,
}

ContactsCard.defaultProps = {
  isTranslated: false,
  personName: '',
  personPhoto: '',
  phoneLink: '',
  photoPath: '',
  withTransform: false,
}

export default ContactsCard
